import styled from '@emotion/styled'

export const StyleOtpWrapper = styled.div`
  display: flex;
  justify-content: space-around;
`

export const StyleOtpInput = styled.input<any>`
  border: 1px solid ${(props) => props.theme.colors.primary};
  background: ${(props) => props.theme.colors.primary50};
  border-radius: 6px;
  outline: none;
  width: calc((100% / 6) - 20px);
  height: 40px;
  text-align: center;
  font-size: 14px;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* For Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
`

export const StyleResendWrapper = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  column-gap: 5px;
`
export const StyleDidReceivedText = styled.p`
  font-size: 12px;
  color: ${(props: any) => props.theme.colors.primaryTextColor};
`

export const StyleResendText = styled.button`
  font-size: 12px;
  color: ${(props: any) => props.theme.colors.primary};
  border: none;
  background-color: ${(props: any) => props.theme.colors.white};
  cursor: ${(props: any) => (props?.disabled ? 'default' : 'pointer')};
`
